/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Detail_Not_FoundInputs */

const en_cover_letters_detail_not_found = /** @type {(inputs: Cover_Letters_Detail_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover letter not found`)
};

const de_cover_letters_detail_not_found = /** @type {(inputs: Cover_Letters_Detail_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anschreiben nicht gefunden`)
};

const fr_cover_letters_detail_not_found = /** @type {(inputs: Cover_Letters_Detail_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettre de motivation introuvable`)
};

const es_cover_letters_detail_not_found = /** @type {(inputs: Cover_Letters_Detail_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carta de presentación no encontrada`)
};

const it_cover_letters_detail_not_found = /** @type {(inputs: Cover_Letters_Detail_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettera di presentazione non trovata`)
};

const nl_cover_letters_detail_not_found = /** @type {(inputs: Cover_Letters_Detail_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivatiebrief niet gevonden`)
};

const pl_cover_letters_detail_not_found = /** @type {(inputs: Cover_Letters_Detail_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List motywacyjny nie został znaleziony`)
};

const fi_cover_letters_detail_not_found = /** @type {(inputs: Cover_Letters_Detail_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saatekirjettä ei löytynyt`)
};

const da_cover_letters_detail_not_found = /** @type {(inputs: Cover_Letters_Detail_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansøgningsbrev ikke fundet`)
};

const sv_cover_letters_detail_not_found = /** @type {(inputs: Cover_Letters_Detail_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personligt brev hittades inte`)
};

/**
* | output |
* | --- |
* | "Cover letter not found" |
*
* @param {Cover_Letters_Detail_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_detail_not_found = /** @type {((inputs?: Cover_Letters_Detail_Not_FoundInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Detail_Not_FoundInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_detail_not_found(inputs)
	if (locale === "fr") return fr_cover_letters_detail_not_found(inputs)
	if (locale === "es") return es_cover_letters_detail_not_found(inputs)
	if (locale === "it") return it_cover_letters_detail_not_found(inputs)
	if (locale === "nl") return nl_cover_letters_detail_not_found(inputs)
	if (locale === "pl") return pl_cover_letters_detail_not_found(inputs)
	if (locale === "fi") return fi_cover_letters_detail_not_found(inputs)
	if (locale === "da") return da_cover_letters_detail_not_found(inputs)
	if (locale === "sv") return sv_cover_letters_detail_not_found(inputs)
	return en_cover_letters_detail_not_found(inputs)
});